import React from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

const EFFECTIVE = "June 2026";

export default function Privacy() {
  return (
    <div className="max-w-2xl mx-auto animate-slide-up py-4" data-testid="privacy-page">
      <div className="flex items-center gap-2 text-race-red mb-2">
        <Shield size={16} />
        <span className="overline">Privacy Policy</span>
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl tracking-tight">Privacy Policy</h1>
      <p className="text-race-sub mt-2 text-sm">Effective {EFFECTIVE} · Text Racing (sanctioned by IBRA)</p>

      <div className="mt-6 space-y-6 text-race-txt leading-relaxed text-sm sm:text-base">
        <section>
          <h2 className="font-heading text-2xl mb-2">Information we collect</h2>
          <p>We collect the information you provide to create and use your account: name, email address, and - if you opt into SMS reminders - your mobile phone number. We also record gameplay data (race results, CPS, contest registrations) and basic technical data (device/browser, IP for region eligibility).</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">How we use it</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Operate contests, scoring, leaderboards, and prize payouts.</li>
            <li>Send the notifications you request (email, web push, and - if opted in - SMS race reminders).</li>
            <li>Verify eligibility (age, region) and protect against fraud.</li>
            <li>Provide support and improve the service.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">SMS &amp; phone number</h2>
          <p><b>We do not sell or share your phone number or SMS opt-in information with third parties or affiliates for their marketing.</b> Your number is used only to deliver the race reminders you asked for. You can opt out anytime by replying STOP or turning reminders off in your profile. See our <Link className="text-race-red" to="/messaging-policy">Messaging Policy</Link>.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Sharing</h2>
          <p>We share data only with service providers that help us run the platform (e.g., payment processing, email/SMS delivery, hosting) under contract, and when required by law. We do not sell personal data.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Your choices</h2>
          <p>You can update your profile, opt out of reminders, or request deletion of your account by emailing <a className="text-race-red" href="mailto:support@textracing.com">support@textracing.com</a>. Some records may be retained as required for legal, tax, and fraud-prevention purposes.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Contact</h2>
          <p>Questions about this policy: <a className="text-race-red" href="mailto:support@textracing.com">support@textracing.com</a>.</p>
        </section>
      </div>

      <div className="mt-8 flex gap-3 flex-wrap">
        <Link to="/messaging-policy" className="text-sm border border-race-line px-4 py-2 rounded-sm hover:border-race-red transition-colors">Messaging Policy</Link>
        <Link to="/terms" className="text-sm border border-race-line px-4 py-2 rounded-sm hover:border-race-red transition-colors">Terms of Service</Link>
      </div>
    </div>
  );
}
